import React from 'react';
import { useEditModeToggle } from './useEditModeToggle';
export var useComponentHelpers = function (disabled) {
    var editorReference = React.useRef(null);
    var _a = useEditModeToggle(disabled), editModeActive = _a.editModeActive, activateReadOnlyMode = _a.activateReadOnlyMode, activateEditMode = _a.activateEditMode;
    return {
        editModeActive: editModeActive,
        activateReadOnlyMode: activateReadOnlyMode,
        activateEditMode: activateEditMode,
        editorReference: editorReference,
    };
};
//# sourceMappingURL=useComponentHelpers.js.map